import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsTooltipModule } from '@cmps/ng-uikit';

import { TooltipConditionalDirective } from './tooltip-conditional.directive';

// TODO will move to uikit
@NgModule({
    declarations: [TooltipConditionalDirective],
    exports: [TooltipConditionalDirective],
    imports: [CmpsTooltipModule, CommonModule],
})
export class CmpsTooltipConditionalModule {}
